import { router } from './router'
import { startup } from './startup'
import { kinetic } from './kinetic'

export function initialize() {

  return async ( dispatch, getState, api ) => {

    // ---------------------------------------------------------
    // For develop: Coming from other app with hash token
    // fragment because localStorage is not shared on localhost
    // ---------------------------------------------------------
    if ( process.env.NODE_ENV == "develop" ) {
      const token = location.hash ? location.hash.substr( 2 ) : null
      if ( token && token.length > 50 ) {
        localStorage.setItem( "token", token )
      }
    }

    // Check access
    try {
      // No server will throw Failed to fetch
      const { meta, data } = await api.access.refresh()

      // Application or Server is down
      if ( meta.code == 200 ) {
        // Save access rights in store
        dispatch( { type: "access", data: data } )
        // Parse params and set in store
        const ready = await dispatch( startup() )
        // @return go or not-authorized
        return ready
      } else {
        throw new Error( "Access denied" )
      }
    }
    //
    catch ( e ) {
      //
      console.log( "> Initialize Error:", e.message )
      if ( process.env.NODE_ENV == "develop" ) {
        console.log( e )
      }
      // Show error
      return "error"
    }
  }
}